import { getPrimeNum } from '@/utils'
// 验证宽高
export function validWH(w, h, def) {
    if (def.indexOf(':')>-1) {
        return getPrimeNum(w, h).join(':')  === def
    }else {
        return [w, h].join('*') === def
    }
};
// 验证时长
export function validLen(target, def) {
    target = +target;
    if (def.indexOf('-')>-1) {
        const [ min, max ] = def.split('-');
        return target>=min && target<=max;
    }else {
        return target <= +def
    }
}